var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666748 6.99984C0.666748 3.50205 3.50229 0.666504 7.00008 0.666504C10.4979 0.666504 13.3334 3.50205 13.3334 6.99984C13.3334 8.5086 12.8058 9.89414 11.9251 10.982L14.3739 13.4308C14.6342 13.6911 14.6342 14.1133 14.3739 14.3736C14.1135 14.634 13.6914 14.634 13.431 14.3736L10.9823 11.9249C9.89438 12.8056 8.50884 13.3332 7.00008 13.3332C3.50229 13.3332 0.666748 10.4976 0.666748 6.99984ZM7.00008 1.99984C4.23867 1.99984 2.00008 4.23843 2.00008 6.99984C2.00008 9.76125 4.23867 11.9998 7.00008 11.9998C9.76149 11.9998 12.0001 9.76125 12.0001 6.99984C12.0001 4.23843 9.76149 1.99984 7.00008 1.99984ZM4.64306 4.30945C5.24557 3.70698 6.07981 3.33317 7.00008 3.33317C7.92035 3.33317 8.7546 3.70698 9.35709 4.30947C9.61744 4.56982 9.61744 4.99193 9.35709 5.25227C9.09674 5.51262 8.67463 5.51262 8.41428 5.25227C8.05163 4.88963 7.55254 4.6665 7.00008 4.6665C6.44762 4.6665 5.94853 4.88962 5.58584 5.25229C5.32548 5.51263 4.90337 5.51262 4.64303 5.25226C4.38269 4.9919 4.3827 4.56979 4.64306 4.30945Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.41621bc0da9aa269b65067c4ad2ae0a5.svg";
export { ForwardRef as ReactComponent };